import { useRef, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import GitHubIcon from "@mui/icons-material/GitHub";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Button, Divider } from "@mui/material";
import LoadingBtn from "../Button/LoadingBtn";

import styles from "../Login/LoginGrid.scss";
import axios from "../../api/axios";
import AuthContext from "../../Context/AuthProvider";
import { useCookies } from "react-cookie";

function RegisterForm() {
  const formObj = {
    emailRef: useRef(),
    usernameRef: useRef(),
    passwordRef: useRef(),
    confirmPasswordRef: useRef(),
  };
  const [cookies, setCookie] = useCookies();
  const navigate = useNavigate();
  const [openSnack, setOpenSnack] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const { auth, setAuth } = useContext(AuthContext);
  const registerSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const email = formObj.emailRef.current.value;
    const username = formObj.usernameRef.current.value;
    const password = formObj.passwordRef.current.value;
    const confirmPassword = formObj.confirmPasswordRef.current.value;
    if (password !== confirmPassword) {
      setOpenSnack(true);
      setMessage("Your password and Confirmed password not match.");
      setSeverity("error");
      return;
    }
    try {
      await axios.post("/auth/register", {
        username,
        email,
        password,
      });

      setOpenSnack(true);
      setMessage("Success");
      setSeverity("success");
      setIsLoading(false);
      try {
        const response = await axios.post("/auth/login", {
          email,
          password,
        });
        const { accessToken, refreshToken } = response?.data;
        setCookie("refreshToken", refreshToken);
        setCookie("accessToken", accessToken);
        setCookie("email", email);
        setAuth({ accessToken, email });
        setIsLoading(false);
        setOpenSnack(true);
        setMessage("Login successful. Redirecting to homepage...");
        setSeverity("success");
        navigate("/", { replace: true });
      } catch (error) {
        setIsLoading(false);
        setOpenSnack(true);
        setMessage(error?.response?.data?.error);
        setSeverity("error");
        return;
      }
      return;
    } catch (error) {
      setOpenSnack(true);
      setMessage(error.response.data.error);
      setSeverity("error");
      setIsLoading(false);
      return;
    }
  };

  if (auth?.email) {
    return (
      <Box className={styles["form"]}>
        <Typography
          variant="h4"
          component="h1"
          textAlign={"center"}
          className={styles["title"]}
          gutterBottom
        >
          You have logged in as&nbsp;
          <span className="highlight-text">{auth.email}</span>
        </Typography>
        <Box textAlign={"center"}>
          <Button variant="contained" route="/">
            Back to Home
          </Button>
          <Button variant="outlined" href="/user">
            Visit your Dashboard
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={styles["form"]}
      sx={{
        width: "fit-content",
        border: "1px solid #FFEAD2",
        padding: 2,
      }}
    >
      <Typography
        variant="h6"
        textAlign={"center"}
        className={styles["title"]}
        gutterBottom
        color="#FFEAD2"
      >
        SIGN UP
      </Typography>
      {/* <Grid container direction="row" justifyContent={"center"}>
        <Grid item>
          <GitHubIcon sx={{ marginY: 1 }} fontSize={"large"} />
        </Grid>
      </Grid>

      <Box textAlign={"center"} mt={2} mb={2}>
        Or
        <Divider sx={{ marginLeft: "5%", marginRight: "5%", marginY: 3 }} />
      </Box> */}

      <Box
        sx={{
          boxShadow: 7,
          padding: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--color4-transparent)",
        }}
      >
        <form id="registration-form">
          <Typography variant="subtitle1" gutterBottom color="#FFEAD2">
            Username
          </Typography>
          <TextField
            required
            hiddenLabel
            fullWidth
            placeholder="Ex. McSpicy"
            variant="filled"
            size="small"
            form="registration-form"
            sx={{ marginBottom: 2 }}
            className={styles["input-text"]}
            inputRef={formObj.usernameRef}
            color="#FFEAD2"
          />
          <Typography variant="subtitle1" gutterBottom color="#FFEAD2">
            Email
          </Typography>
          <TextField
            required
            hiddenLabel
            fullWidth
            id="email"
            placeholder="Ex. mcspicy@email.com"
            variant="filled"
            size="small"
            sx={{ marginBottom: 2 }}
            className={styles["input-text"]}
            inputRef={formObj.emailRef}
            color="#FFEAD2"
          />
          <Typography variant="subtitle1" gutterBottom color="#FFEAD2">
            Password
          </Typography>
          <TextField
            required
            hiddenLabel
            fullWidth
            id="password"
            type="password"
            variant="filled"
            size="small"
            sx={{ marginBottom: 2 }}
            className={styles["input-text"]}
            inputRef={formObj.passwordRef}
            color="#FFEAD2"
          />
          <Typography variant="subtitle1" gutterBottom color="#FFEAD2">
            Confirm Password
          </Typography>
          <TextField
            required
            hiddenLabel
            fullWidth
            id="confirm-password"
            type="password"
            variant="filled"
            size="small"
            sx={{ marginBottom: 2 }}
            className={styles["input-text"]}
            inputRef={formObj.confirmPasswordRef}
            color="#FFEAD2"
          />
          <Box textAlign={"center"}>
            <LoadingBtn
              className="auth-btn"
              loading={isLoading}
              onClick={registerSubmit}
              variant="contained"
              fullWidth={true}
              marginTop="2"
              title="Sign up"
            />
          </Box>
          <Box textAlign={"center"} mt={2} mb={2}>
            <Typography
              variant="subtitle1"
              align={"center"}
              display={"inline"}
              paddingX={1}
              gutterBottom
              color="#FFEAD2"
            >
              Already have an account?
            </Typography>
            <Link className={styles["link"]} to="/login">
              <Typography color="#FFEAD2">Log in here</Typography>
            </Link>
          </Box>
        </form>
      </Box>
      <Snackbar
        open={openSnack}
        autoHideDuration={6000}
        onClose={(event, reason) => {
          if (reason === "timeout") {
            setOpenSnack(false);
          }
        }}
      >
        <Alert severity={severity} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default RegisterForm;
